import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";


import './index.css';
import App from './App';
import StDashLogin from './pages/StDashLogin';
//import StError from './pages/StError';
//import StContactUs from './pages/StContactUs';


import StPvt from './lib/StPvt';
import StAuthGiver from './lib/StAuthGiver';
import StAuthCallback from './lib/StAuthCallback';
import Onboard from './StOnboarding';
import StSiteCreator from "./pages/StSiteCreator.js"
import StUpgradeSuccess from './pages/StUpgradeSuccess.js';
import TemplateEditor from './pages/TemplateEditor/TemplateEditor.js';
import StSitePreview from './pages/StSitePreview.js';
// Setup the router for the website
const turboRouter = createBrowserRouter(
  [
    {
      errorElement: <h1>Error </h1>,

      children: [
        {
          path: "/",
          element: <StDashLogin />,
        },
        {
          path: "/auth",
          element: <StAuthCallback />,
        },
        {
          element: <StPvt />,
          children: [
            {
              path: "/:siteId/*",
              element: <App />
            },
            {
              path: "/onboard",
              element: <Onboard />
            },
            {
              path: "/upgrade",
              element: <StUpgradeSuccess />
            },
            {
              path: "/addSite",
              element: <StSiteCreator />
            }, {
              path: "/edit-template/:templateId",
              element: <TemplateEditor />,
            }, {
              path: "/site-preview",
              element: <StSitePreview />,
            },
          ]
        }

      ]

    }

  ]

);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StAuthGiver>
      <RouterProvider router={turboRouter} />
    </StAuthGiver>
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
